import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '@/mocks/company';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setLoaded(true); }, []);

  const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
  const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

  return (
    <section className="relative w-full h-[600px] md:h-[700px] lg:h-[800px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Máquinas de solda geomembrana profissionais em estoque"
          className="w-full h-full object-cover object-center"
          src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1440,h=912,fit=crop,f=jpeg/A0xVvobDbRIBrVE7/muchas-soldadoras-rojas-mxB7kMa8jKhoPalp.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-900/60 to-foreground-800/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent" />
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-20">
        <div className={`max-w-2xl transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1.5 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-pulse flex-shrink-0" />
            <span className="text-white/80 text-[10px] sm:text-xs font-bold tracking-wider uppercase leading-tight">Importador Oficial — Brasil</span>
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5 uppercase">
            Máquina de<br /><span className="text-primary-400">Solda</span><br />Geomembrana<br /><span className="text-primary-400">Profissional</span>
          </h1>
          <p className="text-white/80 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
            <strong className="text-white">Importadora e distribuidora oficial</strong> de máquinas de solda geomembrana de alta performance — cunha quente, extrusoras e acessórios para impermeabilização. Atendemos todo o Brasil.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-6 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm uppercase tracking-wide"
            >
              <i className="ri-whatsapp-line text-lg" />
              Falar no WhatsApp
            </a>
            <Link
              to="/modelos-de-maquinas"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold px-6 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm uppercase tracking-wide"
            >
              Ver Catálogo
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="mt-6 flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 border border-white/20">
              <i className="ri-phone-line text-white text-sm" />
            </div>
            <span className="text-white/60 text-sm"><span className="text-white font-bold">{companyInfo.phone}</span></span>
          </div>
        </div>
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 opacity-50">
        <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white animate-bounce" />
      </div>
    </section>
  );
}